module.exports = __webpack_public_path__ + "assets/img/00029.c7814243.png";